export default {
  phoneMask: "###########",
  requiredRules: [v => !!v || "This field is required"],
  shortRequiredRules: [v => !!v || "Required"],
  requiredEmailRules: [v => !!v || "E-mail is required"],
  emailRules: [
    v => !!v || "Email required",
    v => (!!v && /\S+@\S+\.\S+/.test(v)) || "E-mail must be valid"
  ],
  phoneRules: [
    v => !!v || "Phone is required",
    v => (!!v && v.length == 11) || "Phone number must be 11 digits"
  ],
  minCountRules: [
    v => !!v || "Sizes is required",
    v => (!!v && v.length > 0) || "Must have at least 1 size"
  ],
  yesNoRules: [v => v != null || "This field is required"],
  nameRules: [
    v => !!v || "This field is required",
    v => (!!v && /^((\w.+\s).+)$/.test(v)) || "Enter First & Last Name"
  ],
  passwordRules: [v => !!v || "Password required"],

  dateRules: [
    v => !!v || "Date is required",
    v => (!!v && v.length == 10) || "Date must be in the format dd/mm/yyyy"
  ],

  titleRules: [
    v => v.length <= 65 || "Title is too long",
    v => !!v || "This field is required"
  ],

  taglineRules: [v => v.length <= 125 || "Tagline is too long"],

  hourRules: [v => !!v || "Hour is required"],

  minuteRules: [v => !!v || "Minute is required"]
};
